import { usePmeTarifacaoPage } from '@/features/proposal-analyses/pme/use-pme-tarifacao.hook';
import { coverageUnitPurePremium } from '@/features/quotes/utils/group-life/coverage-unit-premium.util';
import type { GroupLifeQuoteDetails } from '@/services/group-life';
import { useMemo } from 'react';

/**
 * Prêmio puro ANUAL de uma vida por cobertura, lido da tarifação da proposta —
 * é de onde sai o valor das assistências, que não têm capital.
 *
 * O preço da assistência é fixo na tabela (igual para toda vida), então a
 * primeira página da tarifação basta. Sem cálculo não há tarifação: a busca
 * fica desligada e o mapa vem vazio.
 */
export function usePmeUnitPurePremium(details?: GroupLifeQuoteDetails) {
  const policyId = details?.calculation ? (details.policyId ?? '') : '';
  const pricingPage = usePmeTarifacaoPage(policyId, 'proposal', 1);

  return useMemo(
    () => coverageUnitPurePremium(pricingPage.data?.data ?? []),
    [pricingPage.data]
  );
}
